import { Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'
import { Camera } from '@/types/camera'
import { InputSourceType } from '@/types/deployment'
import { Device } from '@/types/device'
import { getFormattedDateWithTime } from '@/utils/date'
import { DeploymentCameraImage } from './DeploymentCameraImage'
import { DeploymentCameraInfo } from './DeploymentCameraInfo'
import { DeploymentRecentEventsTable } from './DeploymentRecentEventsTable'

type DeploymentCameraTabProps = {
  camera: Camera | null
  inputSourceType: InputSourceType
  device: Device
  appId: string
  onRefresh: () => void
}

export const DeploymentCameraTab = ({
  camera,
  inputSourceType,
  device,
  appId,
  onRefresh
}: DeploymentCameraTabProps) => {
  if (inputSourceType === InputSourceType.MediaFolder) {
    return (
      <PlatformAlert variant="info">
        <FormattedMessage id="deployments.details.tabs.camera.mediaFolder" />
      </PlatformAlert>
    )
  }

  return (
    <Stack>
      {camera?.error?.message && (
        <PlatformAlert variant="error">
          {camera.error.message}
          {camera.error.timestamp && (
            <Text size="xs" mt={4}>
              {getFormattedDateWithTime(camera.error.timestamp)}
            </Text>
          )}
        </PlatformAlert>
      )}

      {camera && (
        <DeploymentCameraInfo
          camera={camera}
          device={device}
          onRefresh={onRefresh}
        />
      )}

      <DeploymentCameraImage
        src={camera?.image}
        cameraName={camera?.camera_name}
      />

      {camera && <DeploymentRecentEventsTable appId={appId} camera={camera} />}
    </Stack>
  )
}
